module.exports = __webpack_public_path__ + "img/10.52a1cac8.png";